
import React, { Component } from 'react';
import { Container, Header, Button, Icon, Divider, Image, Grid, Dropdown, List, Label, Popup, Checkbox, Segment, ButtonGroup, ButtonOr, Menu, MenuItem, Dimmer, Loader, ListItem, Modal, ModalContent, Progress } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { API_URL } from '../App.js';
import axios from 'axios';
// import {retrieveSubjectObject, nounoptions1, nounoptions2, nounoptions3, nounoptionsmodalis, options1, options2, options3, verbPostbases, nounPostbases} from './constants/constants.js'
// import {phrasebook} from './constants/this.state.keriphrases.js';
import {postbasesEndingsUnderlying} from './constants/underlying.js'
// import palette from 'google-palette';
// import shuffle from 'shuffle-array';
import { TagColors } from './HomeHelper.js';
import * as Scroll from 'react-scroll';
import ReactGA from "react-ga4";
import Recorder from './Recorder.js';

// import L from "leaflet";
// import {geoJSONMap} from "./constants/placenames20.js";
// import 'leaflet/dist/leaflet.css';
// import 'leaflet.zoomhome/dist/leaflet.zoomhome.js';
// // import icon from 'leaflet/dist/images/marker-icon.png';
// // import iconShadow from 'leaflet/dist/images/marker-shadow.png';
// import "leaflet-extra-markers/dist/css/leaflet.extra-markers.min.css";
// import "leaflet-extra-markers/dist/js/leaflet.extra-markers.js";
// // import { library } from '@fortawesome/fontawesome-svg-core'
// // import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// // import { faCoffee } from '@fortawesome/free-solid-svg-icons'
// // import { dom } from '@fortawesome/fontawesome-svg-core'
// // dom.watch() // This will kick of the initial replacement of i to svg tags and configure a MutationObserver
// import { library, dom } from '@fortawesome/fontawesome-svg-core'
// import { fas } from '@fortawesome/free-solid-svg-icons'
import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
// import { far } from '@fortawesome/free-regular-svg-icons'
// import { fab } from '@fortawesome/free-brands-svg-icons'
// library.add(fas) 
// dom.i2svg() 

ReactGA.initialize("G-BCN5V0JQN1")

var scroll    = Scroll.animateScroll;

let customFontFam = customFontFam3
let customTitleFontFam = customTitleFontFam3
let customFontFam2 = {fontFamily:customTitleFontFam3}
let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
const isFirefox = typeof InstallTrigger !== 'undefined';

if (isFirefox) {
  customFontFam = customFirefoxTitleFontFam
  customTitleFontFam = customFirefoxTitleFontFam
  customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
  letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px'}
}

let underlineColor = '#b5b5b5'

const options = [
  { key: 's', text: 'Tlingit only', value: 0 },
  { key: 'se', text: 'Tlingit with English', value: 1 },
  { key: 'b', text: 'Book', value: 2 },
]

class KeriPhrases extends Component {
	constructor(props) {
		// console.log(props)
    super(props);

    let currentChapter = decodeURI(props.match.params.num)
    // if (currentChapter == null || !(currentChapter in {'1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17'})) {
    //   currentChapter = '1'
    //   this.props.history.push('/keriphrases/1')            
    // }

		this.state = {
      parseIndex:0,
      presentation:5,
      chapter:currentChapter,
      // activeChapter:'1',
      sortValue:(window.innerWidth < 480 ? 1 : 2),
      keriphrases: {},
      openPopup: -1,
      showModal:-1,
			// map:undefined,
			// markersById:{},
			// overlayMaps:{},
   //    sortValue:0,
			// history: props.location.state === undefined ? [] : props.location.state.history,
			// from: props.location.state === undefined ? '' : props.location.state.from,
		}	   
		scroll.scrollTo(0);
    // let weburl = https://www.haashuka.com

	}

	repeatAudio(audio, event, data) {
	  if (!this.state.playingAudio) {

	    let sound = new Audio(API_URL + "/tlingitaudiolibrary/" +  audio);
	    this.setState({playingAudio: true});

	    sound.play()

	    sound.onended=()=>{
	      this.setState({playingAudio: false});
	    }
	  }
	}

// <link rel="preconnect" href="https://fonts.googleapis.com">
// <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="">
// <link href="https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,100..900;1,100..900&amp;display=swap" rel="stylesheet">
// [leaflet-map address="Juneau, Alaska" zoom="10" height="700" tileurl=https://tiles.stadiamaps.com/tiles/alidade_satellite/{z}/{x}/{y}{r}.jpg zoomcontrol dragging scrollwheel gesture doubleclickzoom]
// [leaflet-geojson src="https://gist.githubusercontent.com/lonnystrunk/fd99e52cfb86c1ebe207506bad898119/raw/fffe18df77df9c39af18a272d708b905571d7c92/placenames.geojson"]
	// <span style="font-family:'Raleway'"><b>{name}</b> #{id}
	// {translation}
	// {location}</span>
// [/leaflet-geojson]
// [geojsonmarker svg property=marker-color 
	// icondefault=#B5B5B5 
	// iconprops="#0056d6,#6EE5FF,#2EA524,#890101,#6F4413,#7c7c7c" 
	// shape=circle 
	// icon=fa-solid 
	// prefix=fa-circle 
	// disableClusteringAtZoom=4  
	// values="#0056d6,#00c7fc,#4f7a28,#555555,#d95000,#b5b5b5" 
	// groups="Water,Ice,Land,Settlement,Trail,Unsure" 
	// visible=1,1,1,1,1,0]
// [fullscreen][zoomhomemap !fit]

	componentDidMount() {
    // this.initialize()

    let keriphrases = {}

    if (Object.keys(this.state.keriphrases).length === 0) {
      axios
        .get(API_URL + "/tlingitphrases", {
          // onDownloadProgress: (progressEvent) => {
            // const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
            // console.log("onDownloadProgress1", totalLength);
            // if (totalLength !== null) {
              // this.progressData1 = 
            // this.setState({progressData1:Math.round( progressEvent.loaded )})
              // console.log(this.progressData1)
            // }
          // },
        }).then(response => {
          keriphrases = response.data;
          // let dictionaryEntry = {}
          // let tlingitAudioKeys = {}
          console.log('Fetched urlDictionary');
          console.log(keriphrases)
          // Object.keys(urlDictionary).forEach(entry => {
          //   // dictionaryEntry = urlDictionary[entry]
          //   urlDictionary[entry]['url'] = entry
          //   urlDictionary[entry]['glossSearch'] = urlDictionary[entry]['gloss'].join('; ')
          //   urlDictionary[entry]['lexicon'] = urlDictionary[entry]['lexicon'].replaceAll('x̱','x̲')
          //   urlDictionary[entry]['lexiconnormal'] = urlDictionary[entry]['lexicon'].replaceAll('x̱','x̲').replaceAll("x̲","x").replaceAll("x̲'","x").replaceAll("x'","x").replaceAll("k̲","k").replaceAll("k̲'","k").replaceAll("k'","k").replaceAll("g̲","g")
          //   urlDictionary[entry]['theme'] = urlDictionary[entry]['theme'].replaceAll('x̱','x̲')
          //   urlDictionary[entry]['lexicon'] = urlDictionary[entry]['lexicon'].replaceAll('x̱','x̲')
          //   // if ('dialect' in urlDictionary[entry]) {
          //     // urlDictionary[entry]['dialect'] = urlDictionary[entry]['dialect']
          //   // }
          //   // if ('soundfile' in urlDictionary[entry]) {
          //   //   // urlDictionary[entry]['soundfile'] = urlDictionary[entry]['soundfile']
          //   //   let mp3Id = urlDictionary[entry]['soundfile'].split('.mp3')[0]
          //   //   // console.log(mp3Id)
          //   //   if (!(mp3Id in tlingitAudioKeys)) {
          //   //     tlingitAudioKeys[mp3Id] = {
          //   //         'key': mp3Id,
          //   //         't': urlDictionary[entry]['lexicon'], 
          //   //         'tnormal': urlDictionary[entry]['lexicon'].replaceAll('k̲','k').replaceAll('x̲','x').replaceAll('x̱','x̲'), 
          //   //         'e': urlDictionary[entry]['glossSearch'], 
          //   //         'mp3':urlDictionary[entry]['soundfile'],
          //   //         'type':'e',
          //   //         'lexiconSources':[
          //   //             {
          //   //             'url':entry,
          //   //             'lexicon':urlDictionary[entry]['lexicon'],
          //   //             'gloss':urlDictionary[entry]['gloss'],
          //   //             'pos':urlDictionary[entry]['pos'],                        
          //   //             },
          //   //             ],
          //   //         }
          //   //   } else {
          //   //     tlingitAudioKeys[mp3Id]['lexiconSources'].concat({
          //   //         'url':entry,
          //   //         'lexicon':urlDictionary[entry]['lexicon'],
          //   //         'gloss':urlDictionary[entry]['glossSearch'],
          //   //         'pos':urlDictionary[entry]['pos'],                        
          //   //         },
          //   //         )
          //   //   }

          //   // }
          //   // dictionarySearchList.push(urlDictionary[entry])

          //   // if ("examples" in urlDictionary[entry]) {
          //   //   urlDictionary[entry]['examples'].map((ex,ind)=>{
          //   //     if (ex[3].length > 0) {
          //   //       // urlDictionary[entry]['example'+(ind+1).toString()+'t'] = ex[1]
          //   //       // urlDictionary[entry]['example'+(ind+1).toString()+'e'] = ex[2]
          //   //       let tstring = ""
          //   //       ex[1].map((k)=>{tstring+=k[0]+' '})
          //   //       // console.log(tstring)
          //   //       if (!(ex[0] in tlingitAudioKeys)) {
          //   //         tlingitAudioKeys[ex[0]] = {
          //   //             'key': ex[0],
          //   //             't': tstring.trim(), 
          //   //             'tnormal': tstring.trim().replaceAll('k̲','k').replaceAll('x̲','x').replaceAll('x̱','x̲').replaceAll('«','“').replaceAll('»','”'), 
          //   //             'e': ex[2], 
          //   //             'mp3':ex[3],
          //   //             'type':'e',
          //   //             'lexiconSources':[
          //   //                 {
          //   //                 'url':entry,
          //   //                 'lexicon':urlDictionary[entry]['lexicon'],
          //   //                 'gloss':urlDictionary[entry]['gloss'],
          //   //                 'pos':urlDictionary[entry]['pos'],                        
          //   //                 },
          //   //                 ],
          //   //             }
          //   //       } else {
          //   //         // console.log('dup')
          //   //         tlingitAudioKeys[ex[0]]['lexiconSources'] = [...tlingitAudioKeys[ex[0]]['lexiconSources'],
          //   //             ...[{'url':entry,
          //   //             'lexicon':urlDictionary[entry]['lexicon'],
          //   //             'gloss':urlDictionary[entry]['gloss'],
          //   //             'pos':urlDictionary[entry]['pos'],                        
          //   //             }]
          //   //             ]
          //   //       }
          //   //     }
          //   //   })
          //   // }
          //   // console.log(entry)
          //   // let moods = {'perfective':'','imperfective':'','future':'','repetitive_imperfective':'','perfective_habitual':'','progressive_imperfective':'','imperative':'','prohibitive':'','conditional':'','hortative':''}
          //   // let currentMood = ''
          //   // if ("verb_paradigms" in urlDictionary[entry]) {
          //   //   Object.keys(urlDictionary[entry]['verb_paradigms']).map((ex,ind)=>{
          //   //     Object.keys(urlDictionary[entry]['verb_paradigms'][ex][1]).map((sentences,sind)=>{
          //   //       // console.log(ex,ind,sentences,sind,urlDictionary[entry]['verb_paradigms'][ex][0])
          //   //       if (urlDictionary[entry]['verb_paradigms'][ex][1][sentences][1].length > 0) {
          //   //         if (urlDictionary[entry]['verb_paradigms'][ex][1][sentences][1].join('; ') !== urlDictionary[entry]['glossSearch']) {
          //   //           if (urlDictionary[entry]['verb_paradigms'][ex][0] in moods) {
          //   //             if (sentences == '3s')
          //   //             moods[urlDictionary[entry]['verb_paradigms'][ex][0]] = [urlDictionary[entry]['verb_paradigms'][ex][1][sentences][0].join('; '), urlDictionary[entry]['verb_paradigms'][ex][1][sentences][1].join('; ')]
          //   //             console.log(moods)
          //   //           }
          //   //         } else {
          //   //           currentMood = urlDictionary[entry]['verb_paradigms'][ex][0]
          //   //         }    
          //   //       }
          //   //     })
          //   //   })
          //   // }



          //   // if ("verb_paradigms_roots" in urlDictionary[entry]) {
          //   //   let xind = 0
          //   //   Object.keys(urlDictionary[entry]['verb_paradigms_roots']).map((ex,ind)=>{
          //   //     Object.keys(urlDictionary[entry]['verb_paradigms_roots'][ex][1]).map((sentences,sind)=>{
          //   //       // console.log(urlDictionary[entry],sentences,sind,ex,ind,urlDictionary[entry]['verb_paradigms_roots'][ex][1][sentences])
          //   //       if (urlDictionary[entry]['verb_paradigms_roots'][ex][1][sentences][1].length > 0) {
          //   //           if (urlDictionary[entry]['verb_paradigms_roots'][ex][0] in moods && moods[urlDictionary[entry]['verb_paradigms_roots'][ex][0]] == '' && urlDictionary[entry]['verb_paradigms_roots'][ex][0] != currentMood) {
          //   //             moods[urlDictionary[entry]['verb_paradigms_roots'][ex][0]] = [urlDictionary[entry]['verb_paradigms_roots'][ex][1][sentences][0].join('; '), urlDictionary[entry]['verb_paradigms_roots'][ex][1][sentences][1].join('; ')]
          //   //             console.log(moods)
          //   //           }       
          //   //       }
          //   //     })
          //   //   })
          //   // }

          //   // console.log(moods)


          //   // dictionary[entry]['fullDefinitionNormalized'] = dictionary[entry]['fullDefinition'].replaceAll(',',' ').replaceAll('⎡(i)⎤','').replaceAll('⎡(t)⎤','');
          //   // dictionary[entry]['keyStringNormal'] = dictionary[entry]['keyString'].replaceAll('ġ','g').replaceAll('ñ','n').replaceAll('ḷ','l').replaceAll('ł','l').replaceAll('ł̣','l').replaceAll('-','').replaceAll(',',' ').replaceAll('(i)','').replaceAll('(t)','');
          //   // dictionarydict[dictionary[entry]['url']]=dictionary[entry]
          
          //   dictionarySearchList.push(urlDictionary[entry])

          // })

          // Object.keys(tlingitAudioKeys).forEach(entry => {
          //   audioSearchList.push(tlingitAudioKeys[entry])
          // })

          // audiolibrary = response.data;
          // console.log('Fetched AudioLibrary');
          // audiolibrary.map((k,index)=> audiolibrary[index]['tnormal'] = audiolibrary[index]['t'].replaceAll('k̲','k').replaceAll('x̲','x'))
          // console.log('Processed AudioLibrary Normalized')
          // this.setState({ audiolibrary: audiolibrary });



          // console.log('Processed dictionary Normalized')
          // console.log(dictionary)
          this.setState({keriphrases: keriphrases});
        });
    }
    // else {
      // this.setState({dictionarySearchList: dictionarySearchList, urlDictionary: urlDictionary});
    // }


	}

  // initialize = () => {
  //   let weburl = 'localhost:3000'
  //   window.location.href = weburl+"/phrasebook?chapter="+encodeURIComponent(this.state.chapter);
  //   // const params = new URLSearchParams(search);
  //   // const foo = params.get('bar');
  //   const queryParameters = new URLSearchParams(window.location.search)
  //   const type = queryParameters.get("chapter")
  //   // const [searchParams] = useParams()
  //   // const newchapter = searchParams.get("chapter")
  //   // console.log(newchapter) 
  // }

  processStyledText = (sentence) => {
      sentence = sentence.replaceAll("???","...")
      sentence = sentence.replaceAll("⟨","").replaceAll("⟩","").replaceAll("«",'"').replaceAll("»",'"')

      return <span>{sentence}</span>


    // sentence = sentence.replaceAll("⟨","").replaceAll("⟩","").replaceAll("«","").replaceAll("»","")
    // let matches = sentence.match(/⎡.*?⎤/g)
    // let matches1 = sentence.match(/{.*?}/g)
    // let matches2 = sentence.match(/_.*?_/g)
    // // console.log(matches2)
    // if (matches !== null || matches1 !== null || matches2 !== null) {
    //   if (matches !== null) {
    //     matches.map((m) => sentence = sentence.replaceAll(m,'<i>'+m.slice(1,-1)+'</i>'))           
    //   }
    //   if (matches1 !== null) {
    //     matches1.map((m) => sentence = sentence.replaceAll(m,m.slice(1,-1)))            
    //   }
    //   if (matches2 !== null) {
    //     matches2.map((m) => sentence = sentence.replace(m,'<sub>'+m.slice(1,-1)+'</sub>'))            
    //   }
    //   return <span dangerouslySetInnerHTML={{__html: sentence}} />    
    // } else {
    //   return <span>{sentence}</span>
    // }


  }

  handleChapterClick = (e, {value}, chapter) => {
    // console.log(e, value, chapter)
    if (chapter == undefined) {
      chapter = value
    } else if (typeof chapter === "object") {
      chapter = e
    }
    this.props.history.push('/tlingitphrases/'+chapter)
    this.setState({chapter:chapter})
    scroll.scrollTo(0);
  }

  handleSortChange = (e, {value}) => {
    if (value === 0 && this.state.sortValue !== 0) {
      this.setState({sortValue: 0})
    } else if (value === 1 && this.state.sortValue !== 1) {
      this.setState({sortValue: 1})
    } else if (value === 2 && this.state.sortValue !== 2) {
      this.setState({sortValue: 2})
    }
  } 


  displayAudioMic = (audioRetrieved,sentenceid) => {
    // console.log(audioRetrieved)
    // console.log(sentenceid)
    return <Popup
            content={
              <List style={{fontFamily:customFontFam}} divided verticalAlign='middle'>
                {audioRetrieved.map((k,kindex)=>{
                  return <ListItem style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                          <Button style={{float:'left', border:(this.state.playingAudio && this.state.clickedAudioIndex === sentenceid+kindex ? 'solid 1px #4a80b5' : 'solid 1px #dededf'),marginLeft:5,backgroundColor:'white', color:'#106181',cursor:'pointer'}} circular icon='volume up' onClick={()=>this.repeatAudio(k['filename'], sentenceid+kindex)} />
                          <div style={{display:'flex',flexDirection:'column',marginLeft:10,padding:'5px 0px'}}>
                            {k['gender'] != 'do_not_wish_to_say' ?
                              <div>{k['gender'].replaceAll('_',' / ')}</div>
                              :
                              null
                            }
                            {k['age'] != 'do_not_wish_to_say' ?
                              <div>{k['age']}</div>
                              :
                              null
                            }
                            {k['village'] != 'do_not_wish_to_say' ?
                              <div>{k['village']}</div>
                              :
                              null
                            }
                            {(k['gender'] == 'do_not_wish_to_say' || k['gender'] === '') && (k['age'] == 'do_not_wish_to_say' || k['age'] === '') && (k['village'] == 'do_not_wish_to_say' || k['village'] === '') ?
                              <div>{'Anonymous Clip'}</div>
                              :
                              null
                            }                            
                          </div>
                        </ListItem>
                })}
                <ListItem style={{display:'flex',flexDirection:'row',alignItems:'center'}}>
                  <Button circular basic style={{opacity:0.9,marginLeft:5,fontSize:'14px'}} onClick={()=>{this.setState({openPopup:-1},()=>{this.setState({showModal:sentenceid})})}} icon='microphone' />
                  <div style={{marginLeft:10,padding:'5px 0px'}}>Submit a Recording for haashuka.com</div>
                </ListItem>
              </List>
              }
            on='click'
            open={this.state.openPopup==sentenceid}
            onClose={()=>this.setState({openPopup:-1})}
            style={{padding:8}}
            position='bottom center'
            trigger={<Button size='small' onClick={()=>{this.setState({openPopup:sentenceid})}} style={{paddingRight:15, marginLeft:5}} circular basic icon>{audioRetrieved.length == 0 ? <Icon style={{color:'#b7b7b7'}} name='microphone' />:<Icon style={{color:'#306190'}} name='volume up' />}<Icon style={{color:'#d2d2d2',paddingLeft:'6px',fontSize:'9px'}} name='chevron down' /> </Button>}
          />
  }

  recordClip = (sentenceid, sentence, siteLocation, english) => {
        // console.log(sentenceid, sentence, siteLocation, english)
        if (english == undefined) {
          english = ''
        }
        // console.log(english, siteLocation)
        return <Modal
            on='click'
            open={this.state.showModal==sentenceid}
            style={{
              maxWidth:500,
              marginTop:(window.innerWidth < 480 ? 10 : 10),
            }}
            closeOnDimmerClick={false}
            onOpen={()=>{
            }}
            onClose={()=>{
              this.setState({showModal:-1})
            }}
          >
          <ModalContent>
            <Icon circular style={{margin:0,color:'#929292',cursor:'pointer',position:'relative',float:'right'}} size='large' onClick={()=>{this.setState({showModal:-1});}} name='x' />
            <Recorder english={english} sentence={sentence} siteLocation={siteLocation} />          
          </ModalContent>
          </Modal>
  }


	render() {

    // let activeChapter = this.state.chapter
    let fontSize = '20px'
    let innerWidthSetting = 600
    if (window.innerWidth < innerWidthSetting) {
      fontSize = '16px'
    }
    // console.log(window.innerWidth)
    let chapterOptions = []
    Object.keys(this.state.keriphrases).map((k)=>{chapterOptions.push({ key: k, text: k+': '+this.state.keriphrases[k]['title'], value: k })})

		return (
			Object.keys(this.state.keriphrases).length === 0 ?
      <div>
      <Dimmer style={{height:(window.innerHeight > 870 ? window.innerHeight: 870)}} active>
        <Loader style={{marginTop:-((870-window.innerHeight)/2)}} size='massive'>
          Loading...
        <Progress style={{marginTop:20}} percent={this.state.fullProgress} size='tiny' />
        </Loader>
      </Dimmer>
      </div>
      :   

      <div className="app" style={{fontFamily:customFontFam}}>
      <Link to={{pathname: "/resources"}} >
        <Button basic style={{fontSize:'14px',paddingLeft:'10px',paddingRight:'15px',margin:'6px 0px'}} icon='left chevron' content='Back to Language Resources' />
      </Link>  
{/*      <Link to={{pathname: "/"}} >
        <Button basic style={{fontSize:'14px',paddingLeft:'10px',paddingRight:'15px',margin:'6px 0px'}} icon='left chevron' content='Back to Homepage' />
      </Link> */}       

      <div style={{display:'flex',flexDirection:'column',margin:fontSize,marginTop:'8px'}}>
      <div style={{fontSize:'19px',lineHeight:'25px',color:'#000000DE',fontWeight:'600',padding:10}}>Tlingit Phrases from DIA Language Sessions</div>
      <div style={{fontSize:'16px',color:'#000000DE',padding:'10px',fontWeight:'400',lineHeight:'23px'}}>
      <span>A collection of Tlingit phrases compiled by Keri Eggleston in 2026. This website is for educational purposes only. </span><span></span>
      </div>
      </div>


      <Grid>
        <Grid.Row>
        {window.innerWidth < innerWidthSetting ?
          null
          :
          <Grid.Column width={4}>
            <Menu fluid vertical tabular>
              {Object.keys(this.state.keriphrases).map((k)=>
                <MenuItem
                  active={this.state.chapter === k}
                  value={k}
                  onClick={this.handleChapterClick}
                >{k+': '+this.state.keriphrases[k]['title']}</MenuItem>
              )}
            </Menu>
          </Grid.Column>
        }

        <Grid.Column stretched width={(window.innerWidth < innerWidthSetting ? 16:12)}>
          <Segment>

        <Grid textAlign='center'>
        <Grid.Row style={{padding:0,margin:0,}}>
          <Grid.Column style={{ padding: 0, margin: 0 }} textAlign='left'>
            <div>

              <div>

                  <div>

                    <div style={{display:'flex',backgroundColor:'#F3F3F3',flexDirection:(window.innerWidth < innerWidthSetting ? 'column':'row'),justifyContent:'space-between',alignItems:'center'}}>
                      
                      <div className='hierarchymain' style={{flex:2,height:'100%',padding:(window.innerWidth < innerWidthSetting ? '5px': '15px 0px'),marginLeft:8}}>
                          {window.innerWidth < innerWidthSetting ? 
                            <Dropdown fluid selection selectOnBlur={false} options={chapterOptions} text={chapterOptions[parseInt(this.state.chapter)-1].text} style={{minWidth:'280px', backgroundColor:'white', fontFamily:customFontFam,fontSize:'15px',fontWeight:400,color:'#000000DE'}}>
                              <Dropdown.Menu style={{maxHeight:'190px'}}>
                                {chapterOptions.map((k,kindex)=>{
                                  return <Dropdown.Item onClick={this.handleChapterClick.bind(this,k.key)} active={parseInt(this.state.chapter)-1 == kindex}>{k.text}</Dropdown.Item>
                                })}
                              </Dropdown.Menu>
                            </Dropdown>
                            :
                            <span className='span2'>{'Chapter '+this.state.chapter+': '+this.state.keriphrases[this.state.chapter]['title']}</span>
                          }
                      </div>
                       

                      <div className='hierarchymain' style={{flex:1,justifyContent:'flex-end',height:'100%',padding:'5px 0px',marginRight:15}}>
                      <span className='span2' style={{marginLeft:15,fontSize:(window.innerWidth < innerWidthSetting ? '15px':'16px')}}>Format:</span>
                      <Dropdown options={options} value={this.state.sortValue} onChange={this.handleSortChange} pointing='top right' style={{backgroundColor:'white',border:'1px solid #e3e3e3',display:'flex',fontFamily:customFontFam,fontSize:(window.innerWidth < innerWidthSetting ? '15px':'16px'),fontWeight:400,color:'#000000DE',padding:6,borderRadius:5,marginLeft:5}} />
                      </div>

                    </div>

                    {this.state.sortValue != 2 ?

                        <div style={{margin:'0px',padding:0}}>

                        {this.state.keriphrases[this.state.chapter]['content'].map((e,eindex)=>{

                          if (e['type'] === 'ex') {

                            return <div style={{margin:20,fontSize:fontSize,lineHeight:'34px'}}>
                                {/*<Icon circular style={{marginRight:'10px',fontSize:'17px',color:'#bfbfbf',cursor:'pointer'}} name='microphone' />*/}
                                {e['tlingit'].map((t,tindex)=>{
                                let entries = [...t[1],...t[2]]
                                let maxLength = (entries.length % 2 === 0 ? entries.length/2 : (entries.length+1)/2)
                                if (entries.length === 0) {

                                  return <span>
                                    <span style={{ marginBottom:'2px',marginTop:'2px',paddingBottom:'1px',marginRight:'3px',fontSize:fontSize, borderBottom:'2px dotted white'}}>
                                    {this.processStyledText(t[0])}
                                    </span>
                                    {' '}
                                  </span>

                                } else {

                                  return <Popup on='click' position={window.innerWidth < innerWidthSetting ? 'bottom left' : 'bottom'} onClose={()=>{this.setState({parseIndex:0})}} content={
                                    <div style={{fontFafmily:customFontFam, fontSize:'16px'}}>
                                      <div style={{textAlign:'center',fontStyle:'italic',color:'#aeaeae',margin:3}}>Possible Entries</div>
                                      {entries.map((k,kindex)=>{
                                        if (kindex === this.state.parseIndex*2 || kindex === this.state.parseIndex*2+1) {
                                        return <div style={{marginTop:15,marginBottom:10}}>
                                            <div style={{display:'flex',alignItems:'center',flexDirection:'row',fontWeight:'500'}}>
                                              {k['url'].length === 0 ?
                                                <span style={{whiteSpace:'nowrap'}}>{k['tlingit']}</span>
                                                :
                                                <a style={{whiteSpace:'nowrap'}} href={"https://www.haashuka.com/"+k['url']} target="_blank">{k['tlingit']}</a>
                                              }

                                              {k['tags'].map((t,tindex)=>
                                                  (tindex === 0 && t.length !== 0 ?
                                                  <span style={{display:'flex',marginLeft:'12px'}}>
                                                    <TagColors homeMode={0} tags={t} width={window.innerWidth} />
                                                  </span>
                                                  :
                                                  null
                                                  )
                                                )}
                                            </div>
                                            <div style={{fontStyle:'italic',marginTop:'5px'}}>{k['english']}</div>
                                        </div>
                                        }})}

                                      {this.state.parseIndex+1 < maxLength+1 && maxLength > 1 ?
                                        <div style={{display:'flex',justifyContent:'center',marginTop:'12px'}}>
                                        <Icon disabled={this.state.parseIndex === 0} circular onClick={() => this.setState({parseIndex: this.state.parseIndex-1})} style={{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'15px'}}  name='chevron left' />
                                        <Label basic circular style={{width:30,color:'#aeaeae',fontWeight:500,height:30,fontSize:14,}}>
                                          {this.state.parseIndex + 1}
                                        </Label>
                                        <Icon disabled={this.state.parseIndex+1 === maxLength} circular onClick={() => this.setState({parseIndex: this.state.parseIndex+1})} style={{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'15px'}}  name='chevron right' />
                                        </div>  
                                        :
                                        null
                                      }      
                
                                    </div>
                                  } trigger={<span>
                                    <span style={{cursor:'pointer', marginBottom:'2px',marginTop:'2px',paddingBottom:'1px',marginRight:'3px',fontSize:fontSize, borderBottom:'2px dotted '+underlineColor}}>
                                      {this.processStyledText(t[0])}
                                    </span>
                                    {' '}
                                    </span>
                                  } />

                                }


                              })}

                                {'audio' in e ?
                                  this.displayAudioMic(e['audio'],eindex)
                                  :
                                  null
                                }

                                {this.state.showModal != -1 ?
                                  this.recordClip(eindex,e['tlingit'].map(str => str[0]).join(" "),'keriphrases',e['english'])
                                  :
                                  null
                                }


                                    {'notes' in e || 'englishLiteral' in e || 'date' in e || 'spakers' in e || 'speakers' in e ?
                                      <Popup hideOnScroll on='click' position='top right' content={
                                        <div style={{fontFamily:customFontFam, fontSize:'14px'}}>
                                          {'englishLiteral' in e ? <div style={{padding:'3px 0px'}}>{'Literal Translation: '+e['englishLiteral']}</div> : null}
                                          {'notes' in e ? <div style={{padding:'3px 0px'}}>{'Notes: '+e['notes']}</div> : null}
                                          {'spakers' in e ? <div style={{padding:'3px 0px'}}>{'Speaker: '+e['spakers']}</div> : null}
                                          {'speakers' in e ? <div style={{padding:'3px 0px'}}>{'Speaker: '+e['speakers']}</div> : null}
                                          {'date' in e ? <div style={{padding:'3px 0px'}}>{'Date: '+e['date']}</div> : null}
                                        </div>
                                      } trigger={
                                        <Icon style={{cursor:'pointer',color:'#e8e8e8',fontSize:'18px',marginLeft:'2px',height:'36px'}} name='info circle'>{'\n'}</Icon>
                                      } />
                                      :
                                      null
                                    }



                            {this.state.sortValue === 1 ?
                              <div style={{fontSize:'16px',color:'grey'}}>{e['english']}</div>
                              :
                              null
                            }

                            </div>

                          } else if (e['type'] === 'text') {
                            return <div style={{fontSize:'16px',padding:"20px 15px",textAlign:'center',lineHeight:"22px",color:'grey'}}>{e['english']}</div>
                          } else if (e['type'] === '!ex') {
                            return <div style={{display:'flex',flexDirection:'column',fontSize:'16px',padding:"10px 15px",marginLeft:"48px",lineHeight:"22px",fontStyle:'italic'}}><div style={{marginBottom:'6px'}}>{e['tlingit']}</div>{this.state.sortValue === 1 ?<div>{e['english']}</div>:null}</div>
                          } else if (e['type'] === 'header') {
                            return <div style={{fontSize:'16px',fontWeight:'bold',fontStyle:'italic',padding:"25px 15px",lineHeight:"22px"}}>{e['english']}</div>
                          } else if (e['type'] === 'break') {
                            return <div style={{height:30}} />
                          }

                        })}
                        </div>
                      
                      :

                        <div style={{margin:'0px',padding:'10px 0px'}}>
                          {this.state.keriphrases[this.state.chapter]['content'].map((e,eindex)=>{
                              if (e['type'] === 'ex') {
                                return <div style={{margin:20,fontSize:fontSize,lineHeight:'34px'}}>
                                <Grid>
                                <Grid.Row style={{padding:0,margin:0,}} columns={2}>
                                <Grid.Column width={7} style={{paddingTop:'6px',paddingLeft:(window.innerWidth < 480 ? '5px':'14px'),paddingRight:'8px'}}>
                                  <div style={{fontSize:'16px',lineHeight:'22px'}}>{e['english']}</div>
                                </Grid.Column>
                                <Grid.Column width={9} style={{paddingRight:'5px',paddingLeft:'8px'}}>
                                  {e['tlingit'].map((t,tindex)=>{
                                    let entries = [...t[1],...t[2]]
                                    let maxLength = (entries.length % 2 === 0 ? entries.length/2 : (entries.length+1)/2)
                                    if (entries.length === 0) {

                                      return <span>
                                        <span style={{ marginBottom:'2px',marginTop:'2px',paddingBottom:'1px',marginRight:'3px',fontSize:fontSize, borderBottom:'2px dotted white'}}>
                                        {this.processStyledText(t[0])}
                                        </span>
                                        {' '}
                                      </span>

                                    } else {

                                      return <Popup on='click' position={window.innerWidth < innerWidthSetting ? 'bottom right' : 'bottom'}  onClose={()=>{this.setState({parseIndex:0})}} content={
                                        <div style={{fontFamily:customFontFam, fontSize:'16px'}}>
                                          <div style={{textAlign:'center',fontStyle:'italic',color:'#aeaeae',margin:3}}>Possible Entries</div>
                                          {entries.map((k,kindex)=>{
                                            if (kindex === this.state.parseIndex*2 || kindex === this.state.parseIndex*2+1) {
                                            return <div style={{marginTop:15,marginBottom:10}}>
                                                <div style={{display:'flex',alignItems:'center',flexDirection:'row',fontWeight:'500'}}>
                                                  {k['url'].length === 0 ?
                                                    <span style={{whiteSpace:'nowrap'}}>{k['tlingit']}</span>
                                                    :
                                                    <a style={{whiteSpace:'nowrap'}} href={"https://www.haashuka.com/"+k['url']} target="_blank">{k['tlingit']}</a>
                                                  }
                                                  {k['tags'].map((t,tindex)=>
                                                      (tindex === 0 && t.length != 0 ?
                                                      <span style={{display:'flex',marginLeft:'12px'}}>
                                                        <TagColors homeMode={0} tags={t} width={window.innerWidth} />
                                                      </span>
                                                      :
                                                      null
                                                      )
                                                    )}
                                                </div>
                                                <div style={{fontStyle:'italic',marginTop:'5px'}}>{k['english']}</div>
                                            </div>
                                            }})}

                                          {this.state.parseIndex+1 < maxLength+1 && maxLength > 1 ?
                                            <div style={{display:'flex',justifyContent:'center',marginTop:'12px'}}>
                                            <Icon disabled={this.state.parseIndex === 0} circular onClick={() => this.setState({parseIndex: this.state.parseIndex-1})} style={{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'15px'}}  name='chevron left' />
                                            <Label basic circular style={{width:30,color:'#aeaeae',fontWeight:500,height:30,fontSize:14,}}>
                                              {this.state.parseIndex + 1}
                                            </Label>
                                            <Icon disabled={this.state.parseIndex+1 === maxLength} circular onClick={() => this.setState({parseIndex: this.state.parseIndex+1})} style={{margin:0,color:'#B1B1B1',cursor:'pointer',fontSize:'15px'}}  name='chevron right' />
                                            </div>  
                                            :
                                            null
                                          }      
                    
                                        </div>
                                      } trigger={
                                        <span>
                                        <span style={{cursor:'pointer', marginBottom:'2px',marginTop:'2px',paddingBottom:'1px',marginRight:'3px',fontSize:fontSize, borderBottom:'2px dotted '+underlineColor}}>
                                          {this.processStyledText(t[0])}
                                        </span>
                                        {' '}
                                        </span>
                                      } />

                                    }


                                  })}

                                  {'audio' in e ?
                                    this.displayAudioMic(e['audio'],eindex)
                                    :
                                    null
                                  }

                                  {this.state.showModal != -1 ?
                                    this.recordClip(eindex,e['tlingit'].map(str => str[0]).join(" "),'keriphrases',e['english'])
                                    :
                                    null
                                  }

                                    {'notes' in e || 'englishLiteral' in e || 'date' in e || 'spakers' in e || 'speakers' in e ?
                                      <Popup hideOnScroll on='click' content={
                                        <div style={{fontFamily:customFontFam, fontSize:'14px'}}>
                                          {'englishLiteral' in e ? <div style={{padding:'3px 0px'}}>{'Literal Translation: '+e['englishLiteral']}</div> : null}
                                          {'notes' in e ? <div style={{padding:'3px 0px'}}>{'Notes: '+e['notes']}</div> : null}
                                          {'spakers' in e ? <div style={{padding:'3px 0px'}}>{'Speaker: '+e['spakers']}</div> : null}
                                          {'speakers' in e ? <div style={{padding:'3px 0px'}}>{'Speaker: '+e['speakers']}</div> : null}
                                          {'date' in e ? <div style={{padding:'3px 0px'}}>{'Date: '+e['date']}</div> : null}
                                        </div>
                                      } trigger={
                                        <Icon style={{cursor:'pointer',color:'#e8e8e8',fontSize:'18px',marginLeft:'2px'}} name='info circle'>{'\n'}</Icon>
                                      } />
                                      :
                                      null
                                    }




                                </Grid.Column>
                                </Grid.Row>
                                </Grid>

                                </div>

                              } else if (e['type'] === 'text') {
                                return <div style={{fontSize:'16px',padding:"25px 15px",textAlign:'center',color:'grey',lineHeight:"22px"}}>{e['english']}</div>
                              } else if (e['type'] === '!ex') {
                                return <Grid>
                                <Grid.Row style={{padding:'10px 0px',margin:0,}} columns={2}>
                                <Grid.Column width={7}>
                                  <div style={{fontSize:'16px',lineHeight:'22px',marginLeft:'40px',fontStyle:'italic'}}>{e['english']}</div>
                                </Grid.Column>
                                <Grid.Column width={9}>
                                  <div style={{fontSize:'16px',lineHeight:'22px',marginLeft:'2px',fontStyle:'italic'}}>{e['tlingit']}</div>
                                </Grid.Column>
                                </Grid.Row>
                                </Grid>
                                // return <div style={{display:'flex',flexDirection:'row',fontSize:'16px',padding:"18px 15px",marginLeft:"24px",lineHeight:"22px"}}><div>{e['english']}</div><div style={{fontStyle:'italic',marginBottom:'6px'}}>{e['tlingit']}</div></div>*/}
                                // return <div><div style={{fontSize:'16px',fontStyle:'italic',padding:"25px 15px",marginLeft:"24px",lineHeight:"22px"}}>{e['tlingit']}</div><div style={{fontSize:'16px',marginLeft:43}}>{e['english']}</div></div>
                              } else if (e['type'] === 'header') {
                                return <div style={{fontSize:'16px',fontWeight:'bold',fontStyle:'italic',padding:"25px 15px",lineHeight:"22px"}}>{e['english']}</div>
                              } else if (e['type'] === 'break') {
                                return <div style={{height:30}} />
                              }
                            
                          })}
                        </div>


                  }


                </div>
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
        </Grid>


          </Segment>
        </Grid.Column>
        </Grid.Row>
      </Grid>


    
			</div>

		);
	}
}
export default KeriPhrases;
